<template>
  <div class="linked-project-detail" :class = "{'clear-header':isWechatBrowser}">
    <my-header title="项目详情" v-if="!isWechatBrowser" :showBack="true"></my-header>
    <div class="case-info-detail" :style="onestopProject.supervisorId || onestopProject.designerId?styleObject:''">
      <div class="project-info">
        <div>{{onestopProject.name}}</div>
        <div style="margin-left: 0.3rem;background:#ffffff;color:#00478e;border-radius:0.07rem;padding:0.05rem 0.09rem 0.05rem 0.09rem;font-size:0.26rem">{{onestopProject.status == '6' ? '已完工' : '施工中'}}</div>
      </div>
      <div class="project-house-type">
        {{onestopProject.houseLayout}}&nbsp;&nbsp;&nbsp;{{onestopProject.area}}㎡
      </div>
    </div>

    <div v-if="onestopProject.foremanId" @click="openPersonDetail(foreman)" class="supervisor-info general-box-shadow">
      <img class="supervisor-avatar" :src="imgUrl + foreman.avatar">
      <div class="supervisor-less-info">
        <div>工长<span class="supervisor-name">{{foreman.name}}</span></div>
        <div class="supervisor-auth">
          <div class="platform-auth"><img src="../../assets/appointment/icon-platform-auth.png"/> <div>平台认证</div></div>
          <div class="supervisor-deposit"><img src="../../assets/appointment/icon-deposit-auth.png"/><div>{{supervisor.guaranteeMoney || 0}} 万</div></div>
        </div>
      </div>
      <div class="evaluate-score">
        <div class="score">{{foreman.score | score}}</div>
      </div>
    </div>
    <div v-if="onestopProject.supervisorId" @click="openPersonDetail(supervisor)" class="supervisor-info general-box-shadow">
      <img class="supervisor-avatar" :src="imgUrl + supervisor.avatar">
      <div class="supervisor-less-info">
        <div>
          <span>监理</span>
          <span class="supervisor-name">{{supervisor.name}}</span>
        </div>
        <div class="supervisor-auth" style="width: 1.8rem">
          <div class="platform-auth"><img src="../../assets/appointment/icon-platform-auth.png"/> <div>平台认证</div></div>
        </div>
      </div>
      <div class="evaluate-score">
        <div class="score">{{supervisor.score | score}}</div>
        <!-- 评分 -->
      </div>
    </div>
    <div v-if="onestopProject.designerId" @click="openPersonDetail(designer)" class="supervisor-info general-box-shadow">
      <img class="supervisor-avatar" :src="imgUrl + designer.avatar">
      <div class="supervisor-less-info">
        <div>
          <span>设计师</span>
          <span class="supervisor-name">{{designer.name}}</span>
        </div>
        <div class="supervisor-auth" style="width: 1.8rem">
          <div class="platform-auth"><img src="../../assets/appointment/icon-platform-auth.png"/> <div>平台认证</div></div>
        </div>
      </div>
      <div class="evaluate-score">
        <div class="score">{{designer.score | score}}</div>
        <!-- 评分 -->
      </div>
    </div>
    <div class="work-progress" v-if="onestopProject.type=='2'">
      <div style="display: flex;justify-content:space-around;">
        <div class="wp-title" @click="changeTabSelect('1')" :class="{'selected': tabItemSelect == '1'}">工长施工</div>
        <div class="wp-title" @click="changeTabSelect('2')" :class="{'selected': tabItemSelect == '2'}">施工图片</div>
        <div v-if="!!global.isMiniProgrm && !!onestopProject.camera" class="wp-title" @click="changeTabSelect('4')" :class="{'selected': tabItemSelect == '4'}">工地直播</div>
        <div class="wp-title" @click="changeTabSelect('3')" :class="{'selected': tabItemSelect == '3'}">账单</div>
      </div>
      <div class="wp-body" v-if="tabItemSelect == '1'">
        <div class="wp-row" v-for="stage in foremanProjectStage" v-if="stage.type != '0'">
          <div class="wp-label" :class="{'active': stage.status === '3'}"><div class="wp-label-border"></div></div>
          <div class="wp-content" :class="{'complete': stage.status === '3'}">{{stage.stageName}}
            <div v-if="stage.status === '3'" class="wp-date">{{stage.completeTime | simpleDayFilter}}</div>
          </div>
        </div>
      </div>
      <div class="wp-body" v-if="tabItemSelect == '2'">
        <div class="none-complete-img" v-if="projectImageList.length ==0">
          <img src="../../assets/icon/icon-none-renderings.png">
          <span style="position: relative;top: -0.2rem;">暂无施工图片</span>
        </div>
        <div v-for="projectImg in projectImageList" style="margin-left: 0.2rem">
          <div class="img-title" style="margin-top: 0.2rem;font-size: 0.36rem;color: #191818;">
            <div>{{projectImg.type | projectImageTypeConvert}}</div>
          </div>
          <div class="foreman-img-list">
            <div v-if="projectImg.attachmentList.length>0" v-for="(recoredImg,index) in projectImg.attachmentList">
              <img class="foreman-img" :src="imgUrl+recoredImg" @click="previewImg(recoredImg,projectImg.attachmentList)">
            </div>
          </div>
        </div>
      </div>
      <div v-if="global.isMiniProgrm && tabItemSelect == '4'">
<!--        <div class="live-card" v-if="!global.isMiniProgrm">-->
<!--          <EZUIKitJs autoplay></EZUIKitJs>-->
<!--        </div>-->
<!--        -->
        <div class="live-card">
          <div @click="decoratingLive" class="openMiniProgrm"></div>
        </div>
      </div>
      <div class="wp-body" v-if="tabItemSelect == '3'">
        <div class="bill-list">
          <div class="bill-item" v-for="fee in projectStageFee" v-if="(fee.type != '3') || (fee.type == '3' && fee.priceStage > 0)">
            <div v-if="(fee.type != '3') || (fee.type == '3' && fee.priceStage>0)" class="bill-info">
              <div class="bill-name">{{fee.name || '合同款'}}</div>
              <div class="bill-status-prepay" v-if="!fee.priceStage">等待工长发起</div>
              <div class="bill-status-prepay" v-if="fee.status == '0' && fee.priceStage">待支付</div>
              <div  class="bill-status-prepay" v-if="stageFee.id == fee.id && customerPayVoucher.stageFeeId == fee.id">{{payVoucherStatus}}</div>
              <div  class="bill-status-paid" v-if="fee.status == '1'">已支付</div>
            </div>
            <div class="bill-status-uncreate" v-if="!fee.priceStage">待生成</div>
            <div class="bill-amount" v-if="fee.priceStage">￥{{fee.priceStage}}</div>
          </div>
        </div>
        <div class="pre-payment-btn" v-if="stageFee.payType != '3' && stageFee.priceStage" @click="openConfirmPaymentOnestop(onestopProject.id,onestopProject.status,onestopProject.type)">支 付</div>
        <div class="pre-payment-btn" v-if="stageFee.payType == '3' && customerPayVoucher.checkStatus == '3'" @click="openConfirmPaymentOnestop(onestopProject.id,onestopProject.status,onestopProject.type)">重新上传支付凭证</div>
        <div style="clear: both"></div>
        <div class="contract-tip">上传合同明细凭证 <span style="color: #feac00">(注意：最多上传30张)</span></div>
        <div class="record-img">
          <div class="image-area">
            <div class="image-view">
              <div v-if="attachmentUrlList.length>0" v-for="(recoredImg,index) in attachmentUrlList">
                <div class="image" :data-index="index" style="position: relative">
                  <img @click="deleteImages(index)" style="width: 0.3rem;height: 0.3rem;position: absolute;right: -0.18rem;top: -0.18rem;" src="../../assets/icon/icon-image-del.png">
                  <img :src="imgUrl+recoredImg" @click = "previewImg(imgUrl+recoredImg,attachmentUrlList)">
                </div>
              </div>
              <div v-if="attachmentUrlList.length<30">
                <div class="image add-image" @click.stop="addCompleteImgs()">
                  <span class="icon-plus"><img src="../../assets/icon/icon-question-upload.png"></span>
                  <span style="display: none;"><input type="file" class="image-input" multiple accept="image/*"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="showContractSaveBtn" class="pre-payment-btn" @click="saveCustomerContractImages()">提交合同明细凭证</div>
        <div style="clear: both"></div>

        <div v-if="delContractModal" class="toast general-tip-modal">
          <img class="close-btn" src="../../assets/icon-close-btn.png" @click="cancelDel()">
          <div class="general-modal-title border-bottom-style">温馨提示</div>
          <div class="general-modal-msg">确定要删除合同凭证吗?<br/>删除后将无法恢复。</div>
          <div class="agree-btn" @click="confirmDel()">确定</div>
        </div>
        <div v-if="delContractModal" class="pay-box"></div>
      </div>
      <div v-if="tabItemSelect == '3' && addStageFee && addStageFee.isConfirm == '0'" style="font-weight: bold;margin-top: 0.2rem;margin-bottom: 0.2rem">
        增项款
      </div>
      <div class="wp-body" v-if="tabItemSelect == '3' && addStageFee && addStageFee.isConfirm == '0'">
        <div class="bill-list">
          <div class="bill-item" style="margin: 0;padding: 0;border: none">
            <div class="bill-info">
              <div class="bill-name">项目增项款</div>
            </div>
            <div style="display: flex;justify-content: space-between">
              <div class="bill-amount">￥{{addStageFee.priceStage}}</div>
              <div class="pre-payment-btn" @click="confirmAddStageFee()">立即确认</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="work-progress" v-if="onestopProject.type=='6'">
      <div style="display: flex">
        <div class="wp-title" @click="changeTabSelect('1')" :class="{'selected': tabItemSelect == '1'}">效果图</div>
        <div class="wp-title" @click="changeTabSelect('3')" :class="{'selected': tabItemSelect == '3'}">账单</div>
      </div>
      <div class="wp-body" v-if="tabItemSelect == '1'">
        <div class="none-complete-img" v-if="onestopProject.renderingsList.length==0">
          <img src="../../assets/icon/icon-none-renderings.png">
          <span style="position: relative;top: -0.2rem;">暂无效果图展示</span>
        </div>
        <div v-if="onestopProject.renderingsList.length>0" v-for="completeImg in onestopProject.renderingsList">
          <img :src="imgUrl+ completeImg" style="width: 6.9rem;height: 4rem;border-radius: 0.06rem;margin-bottom: 0.1rem;" @click="previewImg(completeImg,onestopProject.renderingsList)">
        </div>
      </div>
      <div class="wp-body" v-if="tabItemSelect == '3'">
        <div class="bill-list">
          <div class="bill-item" v-for="fee in projectStageFee" v-if="(fee.type != '3') || (fee.type == '3' && fee.priceStage > 0)">
            <div class="bill-info">
              <div class="bill-name" v-if="fee.percent">{{fee.name || '合同款'}}{{fee.percent * 100}}%</div>
              <div class="bill-name" v-if="!fee.percent">{{fee.name || '合同款'}}</div>
              <div class="bill-status-prepay" v-if="fee.status == '0'">待支付</div>
              <div  class="bill-status-prepay" v-if="stageFee.id == fee.id && customerPayVoucher.stageFeeId == fee.id">{{payVoucherStatus}}</div>
              <div  class="bill-status-paid" v-if="fee.status == '1'">已支付</div>
            </div>
            <div class="bill-amount" v-if="fee.priceStage">￥{{fee.priceStage}}</div>
          </div>
        </div>
        <div class="pre-payment-btn" v-if="stageFee.payType != '3' && stageFee.priceStage" @click="openConfirmPaymentOnestop(onestopProject.id,onestopProject.status,onestopProject.type)">支 付</div>
        <div class="pre-payment-btn" v-if="stageFee.payType == '3' && customerPayVoucher.checkStatus == '3'" @click="openConfirmPaymentOnestop(onestopProject.id,onestopProject.status,onestopProject.type)">重新上传支付凭证</div>
        <div style="clear: both"></div>
      </div>
      <div class="wp-body" v-if="tabItemSelect == '3'">
        <div v-if="onestopProject.contractImages && onestopProject.contractImages.length>0">合同</div>
        <div v-if="onestopProject.contractImages && onestopProject.contractImages.length>0" v-for="completeImg in onestopProject.contractImages">
          <img :src="imgUrl+ completeImg" style="width: 6.9rem;height: 4rem;border-radius: 0.06rem;margin-bottom: 0.1rem;" @click="previewImg(completeImg,onestopProject.contractImages)">
        </div>
      </div>
    </div>
    <div class="work-progress" v-if="onestopProject.type=='1'||onestopProject.type=='5'">
      <div style="display: flex">
        <div class="wp-title" @click="changeTabSelect('1')" :class="{'selected': tabItemSelect == '1'}">监理验收</div>
        <div class="wp-title" @click="changeTabSelect('3')" :class="{'selected': tabItemSelect == '3'}">评价</div>
        <template v-if="onestopProject.type=='1'">
          <div class="wp-title" @click="changeTabSelect('4')" :class="{'selected': tabItemSelect == '4'}">上传合同/付款凭证</div>
        </template>
      </div>
      <div class="wp-body" v-if="tabItemSelect == '1'">
        <div class="wp-row" v-for="stage in supervisorProjectStage" v-if="stage.type != '0'">
          <div class="wp-label" :class="{'active': stage.status === '3'}"><div class="wp-label-border"></div></div>
          <div class="wp-content" :class="{'complete': stage.status === '3'}">
            <div  @click="toggleNodes(stage.id)">
              <div class="stage-title" style="display: flex;justify-content: space-between">
                <div>{{stage.stageName}}</div>
                <img v-if="!stageMap[stage.id]"  src="../../assets/icon/icon-pull-down.png">
                <img v-if="stageMap[stage.id]"  src="../../assets/icon/icon-pull-up.png">
              </div>
              <div v-if="stage.status === '3'" class="wp-date">{{stage.inspectTime | simpleDayFilter}}</div>
            </div>
            <div v-if="stage.categoryList && stage.categoryList.length>0" class="category-list" v-for="category in stage.categoryList" v-show="stageMap[stage.id]">
              <span class="category-name">{{category.name}}</span>
              <div v-for="projectNode in category.onestopProjectNodeList" class="node-list">
                <div style="display: flex;">
                  <div>{{projectNode.nodeNumber}}.</div>
                  <div class="node-content">{{projectNode.nodeContent}}</div>
                  <img style="width: 0.32rem;height: 0.32rem" v-if="projectNode.score == '7'" src="../../assets/onestop/icon-node-qualified.png">
                  <img style="width: 0.32rem;height: 0.32rem"  v-if="projectNode.score != '7'" src="../../assets/onestop/icon-node-unqualified.png">
                </div>
                <div v-if="projectNode.nodeImageArray && projectNode.nodeImageArray.length>0" class="node-img-list">
                  <img v-for="img in projectNode.nodeImageArray" :src="imgUrl+ img | ossProcess(170, 170)" @click="previewImg(img,projectNode.nodeImageArray)">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="wp-body" v-if="tabItemSelect == '4'">
        <div class="wp-list">
          <div v-for="(voucher, index) in userVouchers" class="wp-item">
            <img src="../../assets/icon/icon-image-del.png" class="del-btn" @click.stop="deleteVoucher(index)"/>
            <img :src="imgUrl+ voucher.image" class="wp-image" @click="previewImg(voucher.image,userVouchers)">
          </div>
          <div class="wp-item" @click.stop="addVoucherImage">
            <img src="../../assets/icon/icon-question-upload.png" class="wp-image add-image"/>
            <input type="file" style="display: none;" id="add-voucher-image" multiple accept="image/*">
          </div>
        </div>
      </div>
    </div>

    <div class="client-evaluate" v-if="tabItemSelect == '3' && customerEvaluateList.length > 0">
      <div class="client-evaluate-item" v-for="(evaluate,index) in customerEvaluateList" :class="{'broder-top' : index > 0}">
        <div class="client-info">
          <img class="client-info-img" :src="evaluate.customerUser.avatarUrl">
          <div class="client-info-right">
            <div class="cir-name-star">
              <span class="cir-name">{{evaluate.customerUser.decodeNickname}}</span>
              <div class="cir-star">
                <div class="star-img" :class="evaluate.score <= 0 ? '' : (evaluate.score >=1 ? 'on': '')"></div>
                <div class="star-img" :class="evaluate.score <= 1 ? '' : (evaluate.score >=2 ? 'on': '')"></div>
                <div class="star-img" :class="evaluate.score <= 2 ? '' : (evaluate.score >=3 ? 'on': '')"></div>
                <div class="star-img" :class="evaluate.score <= 3 ? '' : (evaluate.score >=4 ? 'on': '')"></div>
                <div class="star-img" :class="evaluate.score <= 4 ? '' : (evaluate.score >=5 ? 'on': '')"></div>
              </div>
            </div>
            <div class="cir-address-time">
              <span class="cir-address">To : {{evaluate.to}}</span>
              <span class="cir-time">{{evaluate.createTime | time}}</span>
            </div>
          </div>
        </div>
        <p class="client-intro">{{evaluate.content}}</p>
      </div>
    </div>
    <!-- <div class="client-evaluate-form" v-if="tabItemSelect == '3' && isShowEvaluateForm && onestopProject.status == '6'"> -->
    <!-- <div v-if="tabItemSelect == '3'"> -->
      <div class="client-evaluate-form" v-if="isStage === 1">
        <div class="evaluate-star">
          业主评分
        </div>
        <div class="evaluate-text">
          <textarea rows="5" v-model="textArea" placeholder="评论"></textarea>
        </div>
        <div class="evaluateWho">
          <div class="who-radio" @click="whoClick(1)" v-if="isForemanEvaluate && onestopProject.foremanId">
            <img v-if="evaluateWho == 1" src="../../assets/icon/icon-check-box-selected.png">
            <img v-if="evaluateWho != 1" src="../../assets/icon/icon-check-box-unselect.png">工长&nbsp;&nbsp;
          </div>
          <div class="who-radio" @click="whoClick(2)" v-if="isSupervisorEvaluate && onestopProject.supervisorId">
            <img v-if="evaluateWho == 2" src="../../assets/icon/icon-check-box-selected.png">
            <img v-if="evaluateWho != 2" src="../../assets/icon/icon-check-box-unselect.png">监理&nbsp;&nbsp;
          </div>
          <div class="who-radio" @click="whoClick(3)" v-if="isDesignerEvaluate && onestopProject.designerId">
            <img v-if="evaluateWho == 3" src="../../assets/icon/icon-check-box-selected.png">
            <img v-if="evaluateWho != 3" src="../../assets/icon/icon-check-box-unselect.png">设计师
          </div>
          <div style="display: flex">
            <div class="star-img" v-model="score" :class="score <= 0 ? '' : (score >=1 ? 'on': '')" @click="clickScore(1)"></div>
            <div class="star-img" v-model="score" :class="score <= 1 ? '' : (score >=2 ? 'on': '')" @click="clickScore(2)"></div>
            <div class="star-img" v-model="score" :class="score <= 2 ? '' : (score >=3 ? 'on': '')" @click="clickScore(3)"></div>
            <div class="star-img" v-model="score" :class="score <= 3 ? '' : (score >=4 ? 'on': '')" @click="clickScore(4)"></div>
            <div class="star-img" v-model="score" :class="score <= 4 ? '' : (score >=5 ? 'on': '')" @click="clickScore(5)"></div>
          </div>
        </div>
        <div class="evaluate-btn" :class="{'wait-send' : !insertEvaluateStatus}" @click="insertEvaluate()">提交评价</div>
        <div style="clear: both"></div>
      </div>
    <!-- </div> -->
  </div>
</template>
<style lang="scss">
  @import '../../assets/style/common.scss';
  .linked-project-detail{
    background-color: white;
    font-size: 0.36rem;
    .case-info-detail{
      height: 1.64rem;
      // background-image: url('../../assets/icon-default-top-bg.png');
      background: #C4A183;
      color: white;
      .project-info{
        display: flex;
        // justify-content: space-between;
        padding: 0.3rem 0.3rem 0.2rem 0.3rem;
        font-weight: bold;
      }
      .project-house-type{
        width: 2.95rem;
        height: 0.4rem;
        line-height: 0.45rem;
        border-radius: 0.4rem;
        margin-left: 0.3rem;
        text-align: center;
        background: white;
        font-size: 0.24rem;
        color: #feac00;
      }
    }
    .supervisor-info{
      position: relative;
      display: flex;
      width: 6.9rem;
      height: 1.9rem;
      margin: 0.3rem auto 0;
      border-radius: 0.08rem;
      box-shadow: 0rem 0.02rem 0.07rem 0rem
      rgba(0, 0, 0, 0.1);
      .supervisor-avatar{
        width: 1.3rem;
        height: 1.3rem;
        border-radius: 0.06rem;
        margin: 0.3rem 0.2rem;
      }
      .supervisor-less-info{
        margin-top: 0.4rem;
        font-size: 0.28rem;
        color: #7f7d7c;
        .supervisor-name{
          margin-left: 0.2rem;
          font-weight: bold;
          font-size: 0.36rem;
          color: #191818;
        }
        .supervisor-auth{
          display: flex;
          width: 2.95rem;
          height: 0.4rem;
          line-height: 0.45rem;
          border-radius: 0.4rem;
          margin-top: 0.19rem;
          background: #e0dedc;;
          font-size: 0.24rem;
          color: #191818;
          img{
            width: 0.27rem;
            height: 0.28rem;
            margin-top: 0.06rem;
            margin-right: 0.1rem;
          }
          .platform-auth{
            display: flex;
            padding-left: 0.23rem;
          }
          .supervisor-deposit{
            display: flex;
            padding-left: 0.29rem;
          }
        }
      }
      .evaluate-score{
        position: absolute;
        right: 0.5rem;
        // left: 3.6rem;
        top: 0.53rem;
        background: url("../../assets/icon-score-bg.png") no-repeat;
        width: 0.58rem;
        height: 0.8rem;
        line-height: 0.25rem;
        background-size: 100%;
        font-size: 0.18rem;
        color: rgb(224,112,112);
        text-align: center;
        .score{
          margin-left: 0.26rem;
          font-size: 0.24rem;
          font-weight: bold;
        }
      }
    }
    .work-progress{
      padding-left: 0.3rem;
      padding-bottom: 0.2rem;
      .wp-title{
        height: 1.05rem;
        line-height: 1.1rem;
        margin-right: 0.3rem;
        color: #191818;
        font-size: 0.32rem;
      }
      .selected{
        font-weight: bold;
      }
      .wp-body{
        width: 6.9rem;
        padding-top: 0.33rem;
        padding-bottom: 0.6rem;
        box-shadow: 0rem 0.02rem 0.07rem 0rem
        rgba(0, 0, 0, 0.1);
        .node-img-list{
          display: flex;
          flex-wrap: wrap;
          width: 6rem;
          img{
            display: block;
            width: 1.75rem;
            height: 1.75rem;
            margin-top: 0.2rem;
            margin-right: 0.2rem;
          }
        }
        .foreman-img-list{
          width: 6.3rem;
          .foreman-img{
            display: block;
            max-width: 100%;
            margin-top: 0.2rem;
          }
        }
        .bill-list{
          margin-top: -0.3rem;
          .bill-item{
            margin: 0.3rem;
          }
          .bill-info{
            display: flex;
            justify-content: space-between;
            color: #7f7d7c;
            font-size: 0.28rem
          }
          .bill-name{
            margin-bottom: 0.15rem;
            color: #00478e;
            background:rgb(243,249,255);
            padding: 0.1rem;
          }
          .bill-status-prepay{
            color: #feac00;
          }
          .bill-status-paid{
            color: #191818;
          }
          .bill-amount{
            font-size: 0.6rem;
            color: #d54a33;
            span{
              font-size: 0.36rem;
            }
          }
        }
        .pre-payment-btn{
          height: 0.7rem;
          line-height: 0.73rem;
          padding: 0 0.3rem;
          margin-right: 0.3rem;
          background-color: #feac00;
          border-radius: 0.4rem;
          font-size: 0.32rem;
          color: white;
          text-align: center;
          float: right;
        }
        .contract-tip{
          margin-left: 0.3rem;
          margin-top: 0.3rem;
          font-size: 0.28rem;
          color: #7f7d7c;
        }
        .image-view {
          display: flex;
          flex-flow: row wrap;
          margin-top: 0.2rem;
          margin-left: 0.3rem;
          padding-bottom: 0.2rem;
          .image {
            width: 1.64rem;
            height: 1.64rem;
            margin-bottom: 5px;
            margin-right: 14px;
            &.add-image {
              display: flex;
              flex-flow: row wrap;
              justify-content: center;
              align-items: center;
              color: #999;
            }
            .icon-plus img {
              width: 100%;
              height: 100%;
              position: relative;
            }
            img {
              width: 100%;
              height: 100%;
            }

          }
        }
      }
      .none-complete-img{
        font-size: 0.28rem;
        color: #d5dee2;
        padding-top: 1.73rem;
        text-align: center;
        img{
          width: 0.72rem;
          height: 0.6rem;
        }
      }
      .live-card{
        width: 6.9rem;
        height: 3.6rem;
        font-size: 0.28rem;
        color: #d5dee2;
        text-align: center;
        img{
          width: 0.72rem;
          height: 0.6rem;
        }
        .openMiniProgrm{
          position: relative;
          width: 100%;
          height: 100%;
          border-radius: .1rem;
          font-size: 0.32rem;
          color: white;
          background-image: url("../../assets/mine/live_cover.png");
          background-size: 100% 100%;
          content: " ";
          &:after{
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translateX(-50%) translateY(-50%);
            display: block;
            content: " ";
            width: 1rem;
            height: 1rem;
            background-image: url("../../assets/mine/ctrl-play.png");
            background-size: 100% 100%;
          }
        }
      }
      .live-card{
        width: 6.9rem;
        height: 3.6rem;
        font-size: 0.28rem;
        color: #d5dee2;
        text-align: center;
        img{
          width: 0.72rem;
          height: 0.6rem;
        }
        .openMiniProgrm{
          position: relative;
          width: 100%;
          height: 100%;
          border-radius: .1rem;
          font-size: 0.32rem;
          color: white;
          background-image: url("../../assets/mine/live_cover.png");
          background-size: 100% 100%;
          content: " ";
          &:after{
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translateX(-50%) translateY(-50%);
            display: block;
            content: " ";
            width: 1rem;
            height: 1rem;
            background-image: url("../../assets/mine/ctrl-play.png");
            background-size: 100% 100%;
          }
        }
      }
      .wp-row{
        padding-left: 0.2rem;
        margin-top: 0.6rem;
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-between;
        .wp-label{
          position: relative;
          width: 0.36rem;
          margin-top: 0.05rem;
          background: url("../../assets/icon/icon-stage-uncomplete.png") no-repeat;
          background-size: 100%;
          flex-grow: 0;
          flex-shrink: 0;
          .wp-label-border{
            position: absolute;
            height: 100%;
            top:0.45rem;
            left:0.16rem;
            border-left: 1px solid #00478e;
        }
          &.active{
            width: 0.36rem;
            margin-top: 0.05rem;
            background: url("../../assets/icon/icon-stage-complete.png") no-repeat;
            background-size: 100%;
          }
        }
        &:first-child{
          margin-top:0px;
        }
        .wp-content{
          margin-left: 0.2rem;
          color: #7f7d7c;
          font-size: 0.32rem;
          font-weight: bold;
          flex-grow: 1;
          flex-shrink: 0;
          &.complete{
            color: #191818;
          }
          .wp-date{
            font-weight: normal;
            font-size: 0.24rem;
            color: #cecbca;
          }
          .stage-title{
            display: flex;
            justify-content: space-between;
            img{
              width: 0.34rem;
              height: 0.2rem;
              margin-right: 0.3rem;
            }
          }
          .category-list{
            width: 6.0rem;
            .category-name{
              display: inline-block;
              margin-top: 0.3rem;
              margin-bottom: 0.2rem;
              padding: 0.1rem 0.3rem;
              background-color: #e0dedc;
              border-radius: 20px;
              font-size: 0.24rem;
              color: #191818
            }
            .node-list{
              margin-bottom: 0.3rem;
              color: #7f7d7c;
              font-size: 0.28rem;
              font-weight: lighter;
              .node-content{
                width: 5.26rem;
                line-height: 0.4rem;
                text-align: justify;
                margin-right: 0.4rem;
              }
            }
          }
        }
      }
    }
    .client-evaluate{
      background-color: white;
      padding-bottom: 0.2rem;
      padding-left: 0.28rem;
      .client-evaluate-item{
        padding-top: 0.4rem;
        padding-right: 0.28rem;
        .client-info{
          display: flex;
          .client-info-img{
            width: 0.89rem;
            height: 0.89rem;
            border-radius: 1rem;
            background-color: #999;
          }
          .client-info-right{
            flex-grow: 1;
            padding-left: 0.3rem;
            .cir-name-star{
              font-size: 0.32rem;
              color: #1B1E29;
              display: flex;
              justify-content: space-between;
              align-items: center;

              .cir-star{
                display: flex;
                justify-content: flex-end;

                .star-img {
                  width: 0.32rem;
                  height: 0.3rem;
                  margin-left: 0.1rem;
                  background-image: url("../../assets/icon/icon-star-off.png");
                  background-size: 100%;
                }
                .on{
                  background-image: url("../../assets/icon/icon-star-on.png");
                }
                .off{
                  background-image: url("../../assets/icon/icon-star-off.png");
                }
              }
            }
            .cir-address-time{
              margin-top: 0.1rem;
              color: #878E99;
              display: flex;
              justify-content: space-between;
            }
          }
        }
        .client-intro{
          text-align: left;
          margin-top: 0.2rem;
          margin-bottom: 0.38rem;
          color: #878E99;
          line-height: 0.39rem;
        }
      }
      .broder-top{
        border-top: solid 0.02rem #DAE2E5;
      }
    }
    .client-evaluate-form{
      width: 6.9rem;
      margin: 0 auto;
      padding: 0 0.28rem;
      background-color: white;
      .evaluate-star{
        height: 0.78rem;
        display: flex;
        align-items: center;
        font-weight: bold;
      }
      .evaluateWho{
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-grow: 1;
        padding-top: 0.1rem;

        .who-radio{
          display: flex;
          align-items: center;
          justify-content: center;
          img{
            width: 0.37rem;
            height: 0.37rem;
            margin-right: 0.1rem;
          }
        }
        .star-img {
          width: 0.32rem;
          height: 0.3rem;
          margin-left: 0.1rem;
          background-image: url("../../assets/icon/icon-star-off.png");
          background-size: 100%;
        }
        .on{
          background-image: url("../../assets/icon/icon-star-on.png");
        }
        .off{
          background-image: url("../../assets/icon/icon-star-off.png");
        }
      }

      .evaluate-text{
        width: 100%;
        textarea{
          width: calc(100% - 0.57rem);
          height: 1.77rem;
          color: #1B1E29;
          line-height: 0.42rem;
          background-color: #f7f6f5;
          padding: 0.23rem 0.23rem 0.23rem 0.34rem;
          resize: none;
          outline: none;
          font-size: 0.32rem;
          ::placeholder{
            color: #cecbca;
          }
        }
      }
      .evaluate-btn{
        float: right;
        width: 1.68rem;
        height: 0.6rem;
        margin-top: 0.4rem;
        margin-bottom: 1.17rem;
        background-color: #feac00;
        text-align: center;
        line-height: 0.6rem;
        border-radius: 1rem;
        color: white;
        font-size: 0.32rem;
      }
    }
    .wait-send{
      pointer-events: none;
    }
    .clear-header{
      margin-top: -1rem;
    }
  }
  .evaluate-content{
    width:100%;
    height:100%;
    box-sizing: border-box;
    text-align: center;
    line-height: 2rem;
    font-size: 0.35rem;
    font-weight: bolder;
    font-family: NotoSansHans-Medium;
  }
  .wp-list {
    padding: 0 0.3rem;
    display: flex;
    flex-flow: row wrap;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 0.3rem;
    .wp-item {
      position: relative;
      width: 1.64rem;
      height: 1.64rem;
      border-radius: 0.06rem;
      margin-bottom: 0.2rem;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid #eee;
      .del-btn {
        width: 0.3rem;
        height: 0.3rem;
        border-radius: 50%;
        position: absolute;
        right: -0.15rem;
        top: 0;
        transform: translateY(-50%);
        color: #fff;
      }
      .wp-image {
        width: 100%;
        height: 100%;
        display: block;
      }
    }
  }
</style>

<script>
  import {imgUrl,shareIcon} from '../../config'
  import {Toast ,Indicator, MessageBox} from 'mint-ui'
  import Header from '../../components/header/Header'
  import ProjectService from '../../service/customer/ProjectService'
  import ProjectCustomerVoucherService from '../../service/customer/ProjectCustomerVoucherService'
  import SupervisorService from '../../service/SupervisorService'
  import EvaluateService from '../../service/customer/EvaluateService'
  import shareService from '../../service/share/ShareService'
  import statusIconRight from '../../assets/icon_right.png'
  import statusIconWrong from '../../assets/icon_wrong.png'
  import onestopProjectService from '../../service/onestop/OnestopProjectService';
  import baseService from '../../service/BaseService'
  import customerPayVoucherService from '../../service/customer/CustomerPayVoucherService'
  import EZUIKitJs from "../../components/live/EZUIKitJs";
  import appErrorService from '../../service/cloud/AppErrorService'

  export default {
    name: 'LinkedProjectDetail',
    components: {
      EZUIKitJs,
      'my-header': Header,
    },
    data () {
      return {
        onestopProject:{},
        foreman:{},
        supervisor:{},
        designer:{},
        supervisorProjectStage:[],
        foremanProjectStage:[],
        stage:{},//当前工地验收进度
        imgUrl:imgUrl,
        shareIcon:shareIcon,
        customerEvaluateList:[],
        isForemanEvaluate:true,//是否可以评价工长
        isSupervisorEvaluate:true,//是否可以评价监理
        isDesignerEvaluate:true,//是否可以评价设计师
        score:0,
        insertEvaluateStatus:true,
        textArea:'',
        evaluateWho:'',
        projectType:'1',
        isWechatBrowser:this.$verfyBrowserType(),
        isShowAppointBtn:false,
        projectName:'',
        tabItemSelect: '1',
        onestopStatusMap:[],
        isShowEvaluateForm:false,
        isShowStage:[],
        projectImageList:[],
        stageMap:{},
        projectStageFee:[],
        onestopProjectId:'',
        stageFee:{},
        customerPayVoucher:{},
        showContractSaveBtn:false,
        attachmentUrlList:[],
        customerContractImages:'',
        delContractModal:false,
        customerContractIndex:'',
        stageFeeType:'2',
        addStageFee:{},//增项款收费
        styleObject: {
          background: '#384157',
        },
        userVouchers: [],
      }
    },
     computed: {
        isStage() {
          if(this.tabItemSelect == '3' && this.isShowEvaluateForm) {
            //return 1;
            //如果是设计师项目并且status=竣工状态 return 1
            if(this.onestopProject.type === '6' && this.onestopProject.status === '6'){
              return 1
            }else if(this.isShowStage.length > 0 ){
              return 1
            }
          }
          return '';
        }
      },
    created(){
      this.projectStatus = this.$route.query.projectStatus;
      this.projectName = this.$route.query.projectName;
      this.onestopProjectId = this.$route.query.onestopProjectId || '';
      this.isShowAppointBtn = this.$route.query.isShowAppointBtn || false;
      this.projectType = this.$route.query.type;
    },
    beforeMount () {
      document.title = this.$route.meta.title;
      this.getOnestopProjectDetail(this.onestopProjectId);
      if (this.global.tabItemSelect) {
        this.tabItemSelect = this.global.tabItemSelect;
        this.global.tabItemSelect = '';
      }
    },
    methods: {
      changeTabSelect(select){
        console.log(select,'select')
        this.tabItemSelect = select;
        if(this.tabItemSelect == '1'){
          this.getProjectStage(this.onestopProjectId,this.onestopProject.supervisorId,'1');
        }else if(this.tabItemSelect == '2'){
          this.getProjectStage(this.onestopProjectId,this.onestopProject.foremanId,'2');
        }else if(this.tabItemSelect == '4'){
          //TODO 获取摄像头信息
          // this.getProjectStage(this.onestopProjectId,this.onestopProject.foremanId,'2');
        }
      },
      decoratingLive(){
        if(this.onestopProject.camera){
          const { deviceSerial, deviceCode } = this.onestopProject.camera
          if(this.global.isMiniProgrm){
            wx.miniProgram.navigateTo({url: `/pages/decorating/live?deviceSerial=${deviceSerial}&code=${deviceCode}`});
          } else {
            // this.$router.push({name:'DecorationLive',query:{ onestopProjectId: this.onestopProjectId }});
            console.log('暂不支持h5观看,请在水木家居小程序打开');
          }
        } else {
          Toast('项目没有设置摄像头');
        }
      },
      openPersonDetail(person){
        if(person.type == '2'){
          this.$router.push({name:'GangmasterDetail',query:{supervisorId:person.id}});
        }else if(person.type == '1'){
          this.$router.push({name:'SupervisorDetail',query:{supervisorId:person.id}});
        }else if(person.type == '5'){
          this.$router.push({name:'DesignerDetail',query:{supervisorId:person.id,supervisorName:person.name}});
        }
      },
      clickScore(score){
        this.score = score;
      },
      whoClick(num){
         this.evaluateWho = num;
      },
      DetailPerson(person){
        let supervisorId = person.id;
        let supervisorName = person.name;
        if(person.type == '2'){
          this.$router.push({name:'GangmasterDetail',query:{supervisorId,supervisorName}});
        }else if(person.type == '1'){
          this.$router.push({name:'SupervisorDetail',query:{supervisorId,supervisorName}});
        }else if (person.type == '5'){
          this.$router.push({name:'DesignerDetail',query:{supervisorId,supervisorName}});
        }
      },
      async getOnestopProjectDetail(id){
        var result = await ProjectService.getOnestopProjectDetail(id);
        if(result.code == 0){
          this.onestopProject = result.data;
          this.onestopStatusMap = this.onestopProject.onestopStatusMap;
          this.projectName = this.onestopProject.name;
          this.initWechatShare();

          if(this.onestopProject.contractImages){
            let contractImages = this.onestopProject.contractImages.split(',');
            this.$set(this.onestopProject,'contractImages',contractImages);
          }

          if(this.onestopProject.renderings){
            let renderingsList = this.onestopProject.renderings.split(',');
            this.$set(this.onestopProject,'renderingsList',renderingsList);
          }else {
              this.$set(this.onestopProject,'renderingsList',[]);
          }
          if(this.onestopProject.customerContracts){
            this.customerContractImages = this.onestopProject.customerContracts;
            this.attachmentUrlList = this.customerContractImages.split(',')
          }else {
            this.showContractSaveBtn = true;
            this.attachmentUrlList = [];
          }
          if(this.onestopProject.userVouchers){
            this.userVouchers = this.onestopProject.userVouchers;
          }else {
            this.userVouchers = [];
          }

          if(this.onestopProject.foremanId){
            this.evaluateWho = 1
            this.getForemanInfo(this.onestopProject.foremanId);
            this.getProjectStage(this.onestopProjectId,this.onestopProject.foremanId,'2');
            if(!this.onestopProject.supervisorId){
              this.getProjectImageList(this.onestopProjectId);
              this.getProjectStageFee(this.onestopProject.foremanId);
            }
          }
          if(this.onestopProject.supervisorId){
            this.evaluateWho = 2
            this.getSupervisorInfo(this.onestopProject.supervisorId,'1');
            this.getProjectStage(this.onestopProjectId,this.onestopProject.supervisorId,'1');
          }
          if(this.onestopProject.designerId){
            this.evaluateWho = 3
            this.getSupervisorInfo(this.onestopProject.designerId,'5');
            this.getProjectStageFee(this.onestopProject.designerId);
          }
          this.getEvaluateList();
        }else {
          Toast('获取整包项目详情信息失败');
        }
      },
      async getProjectStageFee(supervisorId){
        //整包项目的收费列表
        var result = await ProjectService.getOnestopProjectStageFee(this.onestopProjectId,supervisorId);
        if(result.code == 0){
          this.projectStageFee = result.data.projectStageFeeList;
            //最后一项收费类型不为增项款时显示设置增项款入口
            let lastStageFee = this.projectStageFee[this.projectStageFee.length-1];
            if(lastStageFee && lastStageFee.type == '3'){
                this.addStageFee = lastStageFee;
            }
          for(let psf of this.projectStageFee){
            if(psf.status != '1'){
              this.stageFee = psf;
              break;
            }
          }
          if(this.stageFee.payType == '3'){
            let {code,msg,data} = await customerPayVoucherService.newest(this.onestopProjectId);
            if(code == '0'){
              this.customerPayVoucher = data;
              if(this.customerPayVoucher.checkStatus == '1'){
                this.payVoucherStatus = '凭证待审核';
              } else if(this.customerPayVoucher.checkStatus == '3'){
                this.payVoucherStatus = '凭证审核不通过';
              }
            }
          }
        }else {
          Toast('获取收费列表信息失败');
        }
      },
      async saveCustomerContractImages(){
        if(!this.customerContractImages){
          Toast('请上传合同明细凭证!');
          return
        }
        if(this.customerContractImages.startsWith(',')){
          this.customerContractImages = this.customerContractImages.substring(1,this.customerContractImages.length);
        }
        let {code} = await ProjectService.saveCustomerContracts(this.onestopProjectId,this.customerContractImages);

        if(code == '0') {
          Toast('合同明细凭证提交成功!');
          this.getOnestopProjectDetail(this.onestopProjectId);
          this.showContractSaveBtn = false
        }else {
          Toast('合同明细凭证提交失败!请重新上传!');
          this.contractImages = '';
        }
      },

      //跳转支付整包、监理或工长阶段收费页
      openConfirmPaymentOnestop(onestopProjectId,projectStatus,stageFeeType){
        if(projectStatus == '7'){
          Toast('您的项目已终止!')
        }else{
          this.$router.push({name:'ConfirmPayLinkedBill',query:{projectId:onestopProjectId,stageFeeType}});
        }
        this.global.tabItemSelect = this.tabItemSelect;
      },
      async addCompleteImgs(){
        var that = this;
        if(this.onestopProject.status == '7'){
          Toast('该项目已终止!');
          return
        }else {
          if(!!this.global.isMiniProgrm){
            baseService.uploadImageWxMini().then(res =>{
              //处理image,key
              return baseService.downImage({mediaId:res})
            }).then((url)=>{
              if(!that.showContractSaveBtn){
                that.showContractSaveBtn = true
              }
              that.customerContractImages = that.customerContractImages + ',' +url.name;
              that.attachmentUrlList.push(url.name)
            }).catch(err =>{
              console.log("小程序上传文件失败========",JSON.stringify(err));
              appErrorService.save(err.message, err.stack)
              Indicator.close();
            });
          }else {
            //使用input文件选择
            var fileInput = document.querySelector(".image-input");
            fileInput.click();
            fileInput.onchange = function(){
              for(let file of this.files){
                let fileSize = file.size;
                if(fileSize > 0 && Math.round(fileSize/1024/1024*100)/100 < 20){
                  Indicator.open({
                    text: '加载中...',
                    spinnerType: 'fading-circle'
                  });
                  lrz(file,{width: 1024,fieldName:'imgFile',quality:0.6}).then((rst) =>{
                    return baseService.uploadImage(file);
                  }).then((url) => {
                    //处理image,key
                    if(!that.showContractSaveBtn){
                      that.showContractSaveBtn = true
                    }
                    that.customerContractImages = that.customerContractImages + ',' +url.name;
                    that.attachmentUrlList.push(url.name)
                  }).catch((err) =>{
                    console.log("上传文件失败========",err);
                  }).always(()=>{
                    Indicator.close();
                  });
                }else {
                  Toast('请上传小于20M的图片!');
                }
              }
            }
          }
        }
      },
      deleteImages(index){
        this.delContractModal = true;
        this.customerContractIndex = index;
      },
      cancelDel(){
        this.delContractModal = false;
      },
      confirmDel(){
        let images = this.attachmentUrlList + '';
        let removeStr = this.attachmentUrlList[this.customerContractIndex];
        var recordImagesStr = '';
        var recordImagesArry  = images.split(",");
        for(var i=0; i<recordImagesArry.length; i++) {
          if(recordImagesArry[i] == removeStr) {
            recordImagesArry.splice(i, 1);
          }
        }
        if(recordImagesArry!=null) {
          for (var i = 0; i < recordImagesArry.length; i++) {
            recordImagesStr = recordImagesStr + ',' + recordImagesArry[i];
          }
          this.customerContractImages = recordImagesStr.substring(1, recordImagesStr.length);
        }
        this.attachmentUrlList = recordImagesArry;
        if(!this.showContractSaveBtn){
          this.showContractSaveBtn = true
        }
        this.delContractModal = false;
      },
      async getForemanInfo(id){
        var result=await SupervisorService.getSupervisorDetail(id);
        if(result.code == 0){
          this.foreman = result.data;
        }else {
          Toast('获取工长详细信息失败');
        }
      },
      async getSupervisorInfo(id = '', type = '1'){
        var result = await SupervisorService.getSupervisorDetail(id);
        var typeName = '';
        if (result.code == 0) {
          if(type == '1'){
            this.supervisor = result.data;
            typeName = '监理';
          }else if(type == '5'){
            this.designer = result.data;
            typeName = '设计师';
          }
        } else {
          Toast('获取'+typeName+'项目详细信息失败');
        }
      },
      async getProjectStage(projectId, supervisorId, type){
        var result = await ProjectService.getOnestopProjectStage(projectId, supervisorId);
        if(result.code == 0){
          if(type == '1'){
            this.supervisorProjectStage = result.data.stageList;
            this.getProjectNodeList();
          }else if(type == '2'){
            this.foremanProjectStage = result.data.stageList;
          }
          const isShowStage = result.data.stageList.filter(item=>{
            const has = this.isShowStage.filter(stage => stage.id == item.id)
            if(has.length > 0) return false
            if([17, 16, 24, 25, 29, 30, 37,38].indexOf(item.stageId) > -1 && item.status === '3') return true
            return false
          })
          this.isShowStage.push(...isShowStage)
          for(let stage of this.supervisorProjectStage){
            if(!stage.projectPatrols){
              this.$set(stage,'projectPatrols',[]);
            }
            if(stage.status === '3'){
              stage.statusIcon = statusIconRight;
              this.$set(stage,'inspected',true);
            } else {
              stage.statusIcon = statusIconWrong;
            }
          }
          for(let stage of this.foremanProjectStage){
            if(!stage.projectPatrols){
              this.$set(stage,'projectPatrols',[]);
            }
            if(stage.status === '3'){
              stage.statusIcon = statusIconRight;
              this.$set(stage,'inspected',true);
            } else {
              stage.statusIcon = statusIconWrong;
            }
          }
        }else {
          Toast('获取工地验收进度信息失败');
        }
      },
      async getProjectNodeList(){
        for (let stage of this.supervisorProjectStage){
          if(stage.status == '2' || stage.status == '3'){
            this.$set(this.stageMap, stage.id, false);
            let {code,data:nodeList} = await onestopProjectService.nodeList(this.onestopProjectId,stage.stageId);
            this.$set(stage,'categoryList',nodeList.categoryList);
            for (let category of nodeList.categoryList) {
              let nodeImageArray = [];
              for(let node of category.onestopProjectNodeList){
                if(node.recordImages){
                  nodeImageArray = node.recordImages.split(',');
                }
                this.$set(node,'nodeImageArray',nodeImageArray);
              }
            }
          }else {
            this.$set(stage,'categoryList',[]);
          }
        }
      },
      toggleNodes(id){
        this.$set(this.stageMap, id, !this.stageMap[id]);
      },
      async getEvaluateList(){
        this.customerEvaluateList = [];
        if(this.onestopProject.supervisorId){
          this.maxEvaluate += 1;
          let result = await EvaluateService.evaluateList(this.onestopProject.supervisorId,this.foreman.companyId,this.onestopProjectId,this.onestopProject.type);
          if(result.code == 0){
            if(result.data.length > 0){
              this.isSupervisorEvaluate = false;
              for(let eva of result.data){
                this.$set(eva,'to','监理');
                this.customerEvaluateList.push(eva)
              }
            }
          }else {
            Toast('获取评价信息失败');
          }
        }
        if(this.onestopProject.foremanId) {
          this.maxEvaluate += 1;
          let res = await EvaluateService.evaluateList(this.onestopProject.foremanId, this.supervisor.companyId, this.onestopProjectId, this.onestopProject.type);
          if (res.code == 0) {
            if(res.data.length > 0){
              this.isForemanEvaluate = false;
              for(let eva of res.data){
                this.$set(eva,'to','工长');
                this.customerEvaluateList.push(eva)
              }
            }
          } else {
            Toast('获取评价信息失败');
          }
        }

        if(this.onestopProject.designerId) {
          this.maxEvaluate += 1;
          let res = await EvaluateService.evaluateList(this.onestopProject.designerId, this.supervisor.companyId, this.onestopProjectId, this.onestopProject.type);
          if (res.code == 0) {
            if(res.data.length > 0){
              this.isDesignerEvaluate = false;
              for(let eva of res.data){
                this.$set(eva,'to','设计师');
                this.customerEvaluateList.push(eva)
              }
            }
          } else {
            Toast('获取评价信息失败');
          }
        }

        this.isShowEvaluateForm = (this.onestopProject.supervisorId && this.isSupervisorEvaluate)
          || (this.onestopProject.foremanId && this.isForemanEvaluate)
          || (this.onestopProject.designerId && this.isDesignerEvaluate)
        console.log(this.isShowEvaluateForm,'isShowEvaluateForm')
     },
      async insertEvaluate(){
        this.insertEvaluateStatus = false;
        let supervisorId;
        if (this.evaluateWho === 1) {
          supervisorId = this.foreman.id;
        } else if (this.evaluateWho === 2) {
          supervisorId = this.supervisor.id;
        } else if (this.evaluateWho === 3) {
          supervisorId = this.designer.id;
        }else {
          this.insertEvaluateStatus = true;
          Toast('评价人员未选择');
          return;
        }
        if(this.score == 0){
          this.insertEvaluateStatus = true;
          Toast('请选择评分');
          return;
        }
        var result = await EvaluateService.evaluatePost(supervisorId,this.onestopProjectId,this.score,this.textArea,'');
        if(result.code == '0'){
          this.getEvaluateList();
          this.score = 0;
          this.textArea = '';
          this.evaluateWho = '';
          this.insertEvaluateStatus = true;
          Toast('提交成功！');
        }else {
          this.insertEvaluateStatus = true;
          Toast('评价未成功，请稍后重试！');
        }
      },
      async initWechatShare(){
        let title = this.projectName;// 分享标题
        let desc = "水木家居商城在建项目，欢迎各位莅临参观！"; // 分享描述
        let link = window.location.href; // 分享链接
        link = link.replace(/#/, '?#');
        await shareService.wechatShare(title,desc,link,this.shareIcon);
      },
      openCustomerVisitReservation(projectId,projectAddress,foremanName){
        if(!projectAddress){
          projectAddress = '暂无详细地址';
        }
        if(!foremanName){
          foremanName = '暂未分配工长'
        }
        this.$router.push({name:'CustomerVisitReservation',query:{projectId,projectAddress,foremanName}});
      },
      previewImg(currentImage,imageList){
        let previewImageList = [];
        for (let image of imageList){
          let previewImage = this.imgUrl + image;
          previewImageList.push(previewImage);
        }
        wx.previewImage({
          current: currentImage,
          urls: previewImageList
        });
      },
      previewFullImg(currentImage,imageList){
        wx.previewImage({
          current: currentImage,
          urls: imageList
        });
      },
      toLinkedProjectStageFee(onestopProjectId,stageFeeType){
        this.global.tabItemSelect = this.tabItemSelect;
        this.$router.push({name:'LinkedProjectStageFee',query:{onestopProjectId,stageFeeType}});
      },
      async getProjectImageList(projectId){
        var result = await ProjectService.getProjectImageList(projectId);
        if(result.code == 0 && result.data){
          for (let projectImg of result.data){
            projectImg.attachmentList = projectImg.images.split(',');
            this.projectImageList.push(projectImg)
          }
          console.info(this.projectImageList)
        }else {
          Toast('获取工地实拍信息失败');
        }
      },
      async confirmAddStageFee(){
          var result = await ProjectService.confirmStageFee(this.addStageFee.id);
          if(result.code == 0){
              Toast('确认增项款操作成功');
              this.getProjectStageFee(this.onestopProject.foremanId);
          }else {
              Toast('确认增项款操作失败，请稍后重试!');
          }
      },
      async addVoucherImage(event){
        //小程序选择文件
        if(!!this.global.isMiniProgrm){
          baseService.uploadImageWxMini().then(res =>{
            baseService.downImage({ mediaId:res }).then((data)=>{
              //处理image,key
              this.saveCustomerVoucher(data.name)
              Indicator.close();
            });

          }).catch(err =>{
            console.log("上传文件失败========",err);
            Indicator.close();
          });
        } else {
          //使用input文件选择
          let fileInput = document.querySelector("#add-voucher-image");
          fileInput.click();
          let that = this;
          fileInput.onchange = function(){
            let file = this.files[0];
            if(this.outerHTML){
              this.outerHTML=this.outerHTML;
            }else{      //FF
              this.value="";
            }
            Indicator.open({
              text: '加载中...',
              spinnerType: 'fading-circle'
            });
            lrz(file,{width: 1024,fieldName:'imgFile',quality:0.6}).then((rst) =>{
              return baseService.uploadImage(file);
            }).then((data) => {
              //处理image,key
              return that.saveCustomerVoucher(data.name)
            }).catch((err) =>{
              console.log("上传文件失败========",err);
            }).always(()=>{
              Indicator.close();
            });
          }
        }
      },
      async deleteVoucher(index) {
        try {
          MessageBox.confirm('确定要删吗？删除后将无法恢复。').then((res) => {
            const voucher = this.userVouchers[index]
            console.log('res===confirm ', voucher)
            if (voucher) {
              ProjectCustomerVoucherService.remove(voucher).then(res => {
                if(res.code == 0) {
                  this.userVouchers.splice(index, 1)
                } else {
                  Toast('删除失败');
                }
              })
            }
          }).catch(e =>{
            console.error("删除图片出错：",e);
          });
        } catch (e) {
          console.error(e.message, e)
        }
      },
      async saveCustomerVoucher(image) {
        try {
          const projectId = this.onestopProjectId
          const { code, data: voucher} = await ProjectCustomerVoucherService.save({ projectId, image })
          if (code == 0) {
            this.userVouchers.push(voucher)
          }
          return voucher
        } catch (e) {
          console.error(e.message, e)
        }
      }
    }
  }
</script>

